import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Switch,
} from "@mui/material";
import { Box } from "@mui/system";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import EditIcon from "@mui/icons-material/Edit";

const StaffStatus = () => {
  let navigate = useNavigate();
  const { user } = useAuth();
  const [modalState, setModalState] = useState({
    open: false,
    name: null,
    courseCode: null,
    disabled: null,
  });
  const [open, setOpen] = React.useState(false);

  const handleSnackClick = () => {
    setOpen(true);
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleClose = () => {
    setModalState({ ...modalState, open: false });
  };
  const handleOpen = (row) => {
    setModalState({
      name: row[1],
      id: row[0],
      open: true,
      disabled: row[4] == "Active" ? false : true,
    });
  };
  const handleDisable = () => {
    api
      .get("staffStatus/disableStatus/", {
        params: { id: modalState.id, status: modalState.disabled },
      })
      .then((response) => {
        handleSnackClick();
        navigate("/system_setting/status");
      })
      .catch((err) => {
        console.log(err);
      });
    handleClose();
  };
  const columnHead = [
    {
      label: "Status ID",
      name: "status_id",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      label: "Status Type",
      name: "status",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Expected Load",
      name: "expected_load",
      options: {
        filter: true,
      },
    },
    {
      label: "Maximum Load",
      name: "max_load",
      options: {
        filter: true,
      },
    },
    {
      label: "Action",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{ width: "100px", display: "flex", alignItems: "center" }}>
              {user.roles.includes(1103) && (
                <EditIcon
                  color="primary"
                  onClick={() => {
                    navigate("/system_setting/status/editStatus", {
                      state: tableMeta.rowData,
                    });
                  }}
                />
              )}
              {/*<NavLink to={`/deleteCourse/${value}`}>*/}
              {user.roles.includes(1103) && (
                <Switch
                  checked={value == "Active" ? true : false}
                  onClick={() => {
                    // tableMeta.tableData.map(row => {
                    //   console.log(row[0])
                    // })
                    console.log(tableMeta.rowData[0]);
                    handleOpen(tableMeta.rowData);
                  }}
                />
              )}
              {/* {tableMeta.tableData.filter((row) => {
                console.log(row.status);
              })} */}
              {/*</NavLink>*/}
            </div>
          );
        },
      },
      name: "delete",
    },
  ];
  const options = {
    selectableRows: "none",
  };

  const [tableData, setTableData] = useState([]);
  const api = useAxiosPrivate();
  useEffect(() => {
    api
      .get("staffStatus/")
      .then((res) => {
        setTableData(res.data.data);
        console.log(res.data);
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    <>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleSnackClose}>
        <Alert
          onClose={handleSnackClose}
          severity="success"
          sx={{ width: "100%" }}>
          Modified Successfully
        </Alert>
      </Snackbar>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            navigate("/system_setting/status/addStatus");
          }}>
          Add Status +
        </Button>
      </Box>
      <MUIDataTable
        title="Status List"
        data={tableData}
        columns={columnHead}
        // options={[]}
      />
      <Dialog open={modalState.open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">
          {modalState.disabled ? "Enable " : "Disable "}
          {modalState.name} ?
        </DialogTitle>
        <DialogContent>
          {modalState.disabled
            ? "You will be able to use it once it is activated"
            : "You are about to disable this status"}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ color: "teritiary.darker" }}>
            cancel
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleDisable}>
            {modalState.disabled ? "Enable" : "Disable"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default StaffStatus;
